module.exports = __webpack_public_path__ + "static/media/wine-glass-alt.62870ba7.svg";